import { useState, useRef, useEffect } from "react";
import Avatar from "@shared/v2/Avatar";
import { Popover } from "@shared/v2/Popover";
import { useGetAgentState } from "../agentOrPondHookHelpers";

const FormAgentOrPondSelect = ({
  enableLeadPonds = false,
  primaryAgent,
  leadPond,
  onChange = (params) => {},
  placeholder = "",
}) => {
  const target = useRef(null);
  const [state, setState, handleChange] = useGetAgentState(enableLeadPonds, true);
  const [primaryAgentModel, setPrimaryAgent] = useState(null);
  const [leadPondModel, setLeadPond] = useState(leadPond);

  useEffect(() => {
    if (!state?.allAssignableAgents.length) return;

    if (!primaryAgentModel) {
      const agent = state.allAssignableAgents.find((a) => a.id === primaryAgent);
      if (agent) setPrimaryAgent(agent);
    }
  }, [primaryAgent, state.allAssignableAgents]);

  const handleAgentSelect = (agent) => {
    const params = {
      primary_agent: agent.id,
    };
    setLeadPond(null);
    setPrimaryAgent(agent);
    setState((state) => ({ ...state, show: false }));
    onChange(params);
  };

  const handlePondSelect = (leadPond) => {
    const params = {
      lead_pond: leadPond.id,
    };
    setState((state) => ({ ...state, show: false }));
    setLeadPond(leadPond);
    setPrimaryAgent(null);
    onChange(params);
  };

  const setShowDropdown = (show) => setState((state) => ({ ...state, show }));

  const { filter, filteredAssignableAgents, filteredAssignablePonds } = state;

  return (
    <div className="tw-relative" ref={target} data-cy="pond_agent_field">
      <Popover
        placement="bottom"
        show={state.show}
        onOpen={() => setShowDropdown(true)}
        onClose={() => setShowDropdown(false)}
        maxHeight={400}
      >
        <Popover.Trigger>
          <button
            className="tw-text-[14px] tw-flex tw-items-center tw-h-[32px] tw-py-[6px] tw-bg-tinted-gray-50 tw-w-full tw-border-[1px] tw-border-solid tw-border-neutral-gray-30 tw-text-left tw-truncate"
            type="button"
            onClick={() => setShowDropdown(true)}
          >
            <div
              className={`tw-flex-1 ${!leadPondModel && !primaryAgentModel ? "tw-text-neutral-gray-50" : ""}`}
            >
              {leadPondModel ? leadPondModel.name : primaryAgentModel ? primaryAgentModel.name : placeholder}
            </div>
            <input
              type="hidden"
              value={leadPondModel ? leadPondModel.id : primaryAgentModel ? primaryAgentModel.id : null}
              name={leadPondModel ? "lead_pond_id" : "primary_agent_id"}
            />
            <i className="fa fa-caret-down tw-text-[15px] tw-text-neutral-gray-75 tw-px-2" />
          </button>
        </Popover.Trigger>
        <Popover.Content className="!tw-z-[3001] tw-max-h-[400px]">
          <div className="tw-p-4">
            <input
              className="tw-w-full tw-border tw-border-gray-10"
              autoFocus={true}
              onChange={handleChange}
              placeholder="Search..."
              value={filter}
            />
          </div>

          {filteredAssignablePonds.length > 0 && (
            <p className="tw-text-[12px] tw-pt-1 tw-px-2 tw-bg-neutral-gray-10">Pond</p>
          )}
          {filteredAssignablePonds?.map((pond) => (
            <Popover.Item key={pond.id} onClick={() => handlePondSelect(pond)}>
              <div className="tw-overflow-hidden tw-flex tw-items-center tw-gap-[8px]" title={pond.name}>
                <Avatar src={pond.image_src} alt={pond.name} />
                <div className="tw-flex-1 tw-whitespace-nowrap [text-overflow:ellipsis] tw-overflow-hidden">
                  {pond.name}
                </div>
              </div>
            </Popover.Item>
          ))}

          {filteredAssignableAgents.length > 0 && (
            <p className="tw-text-[12px] tw-pt-1 tw-px-2 tw-bg-neutral-gray-10">Team</p>
          )}
          {filteredAssignableAgents?.map((agent) => (
            <Popover.Item key={agent.id} onClick={() => handleAgentSelect(agent)}>
              <div className="tw-overflow-hidden tw-flex tw-items-center tw-gap-[8px]" title={agent.name}>
                <Avatar src={agent.image_src} alt={agent.name} />
                <div className="tw-flex-1 tw-whitespace-nowrap [text-overflow:ellipsis] tw-overflow-hidden">
                  {agent.name}
                </div>
              </div>
            </Popover.Item>
          ))}
        </Popover.Content>
      </Popover>
    </div>
  );
};

export default FormAgentOrPondSelect;
